<template>
  <div class="coach-main">
    <img
      class="coach-bg"
      src="@/assets/images/home/coach.png"
      alt="coach-bg"
      loading="lazy"
    />
    <div class="coach-content">
      <h2>Play with a Pro (in &lt;1 minute)</h2>
      <p>
        Our elite coaches are in the top 1% and can help you take your play to
        the next level.
      </p>
      <div>
        <span class="how-it-works" @click="$emit('onCoachHowToClick')"
          >How it works&nbsp; ›</span
        >
      </div>
      <span class="btn btn-red join-btn" @click="startTraining"
        >START TRAINING</span
      >
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    trackCTAClick (button) {
      this.trackAnalyticsEvent("Click CTA from Homepage", {
        CTA_name: button,
      })
    },
    startTraining () {
      this.trackCTAClick("Start Training")
      this.$emit("onCtaClick")
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_mixins.scss";
.coach-main {
  display: flex;
  justify-content: center;
  align-items: center;
  @include phone-down {
    flex-direction: column;
  }
  .coach-bg {
    @include tablet-down {
      width: 35rem;
    }
    @include phone-down {
      margin-left: 3rem;
    }
  }
  .coach-content {
    margin-left: 2.4rem;
    @include phone-down {
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
    h2 {
      font-family: Proxima Nova;
      font-style: normal;
      font-weight: 700;
      font-size: 3.5rem;
      line-height: 4.3rem;
      color: #111;
      margin: 0 0 2.5rem;
      @include tablet-down {
        font-size: 2.8rem;
        line-height: 3.4rem;
        margin-bottom: 0.7rem;
      }
    }
    p {
      font-family: Proxima Nova;
      font-style: normal;
      font-weight: 400;
      font-size: 2rem;
      line-height: 152.8%;
      color: #111;
      width: 42.6rem;
      margin: 0 0 0.6rem;
      @include tablet-down {
        font-size: 1.8rem;
        line-height: 152.8%;
      }
      @include phone-down {
        padding: 0 1.6rem;
        width: 100%;
      }
    }
    .how-it-works {
      font-family: Proxima Nova;
      font-style: normal;
      font-weight: 600;
      font-size: 1.8rem;
      line-height: 2.2rem;
      color: #239796;
      cursor: pointer;
      transition: all 0.2s;
      &:hover {
        color: #131417;
      }
    }
    .join-btn {
      background-color: #47D8D7;
      color: #201D1C;
      margin-top: 4rem;
      display: inline-block;
      border-radius: 4px;
      font-family: "Proxima Nova";
      font-style: normal;
      font-weight: 600;
      font-size: 1.5rem;
      line-height: 1.8rem;
      letter-spacing: 0.08em;
      padding: 1.4rem 6.6rem;
      transition: all 0.1s;
      @include phone-down {
        position: absolute;
        // bottom: 3rem;
        // top: 41rem;
        bottom: 2.8rem;
        left: 1.6rem;
        right: 1.6rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/CoachSection/CoachMain.vue